import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/demand/booked-loads");

export const Route = createFileRoute("/demand/booked-loads")({
  head: () => ({
    meta: [
      { title: "Booked loads — LevelLoad" },
      { name: "description", content: "Booked loads — LevelLoad transport planning." },
      { property: "og:title", content: "Booked loads — LevelLoad" },
      { property: "og:description", content: "Booked loads — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
